<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice-dollar', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn v-if="create_access" color="primary" class="mb-5" @click="dialog_bulk_upload = true">Carga masiva</v-btn>
      <v-btn v-if="create_access" class="mb-5 ml-3" outlined color="primary" @click="dialog_upload_payslip = true">Carga individual</v-btn>

      <PayslipList ref="payslips" />

      <ModalBulkUpload :dialog="dialog_bulk_upload" @updateDialog="(value) => (dialog_bulk_upload = value)" @imported="reloadList" />
      <ModalUploadPayslip :dialog="dialog_upload_payslip" @updateDialog="(value) => (dialog_upload_payslip = value)"
        @uploaded="reloadList" />
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import PayslipList from "./PayslipList.vue";
import ModalBulkUpload from "./ModalBulkUpload.vue";
import ModalUploadPayslip from "./ModalUploadPayslip.vue";

export default {
  components: { Title, PayslipList, ModalBulkUpload, ModalUploadPayslip },
  mixins: [RolMixin],
  data() {
    return {
      page_title: "Recibos de sueldo",
      dialog_bulk_upload: false,
      dialog_upload_payslip: false,
    };
  },
  methods: {
    reloadList() {
      this.$refs.payslips.loadList(this.$refs.payslips.service);
    },
  },
};
</script>
